import { NgModule } from "@angular/core";
import { routing } from './petition-pages.routing';
import { NamedDialog, TYTCommonModule } from "@tytapp/common";
import { CommonModule } from "@angular/common";
import { ImageCropperModule } from "ngx-image-cropper";
import { PollsModule } from "@tytapp/polls";
import { FormsModule } from "@angular/forms";
import { UserModule } from "@tytapp/user";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonUiModule } from "@tytapp/common-ui";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { PetitionListComponent } from "./petition-list/petition-list.component";
import { PetitionPageComponent } from "./petition-page/petition-page.component";
import { PetitionRecentSignersComponent } from "./petition-recent-signers/petition-recent-signers.component";
import { PetitionUpdatesComponent } from './petition-updates/petition-updates.component';
import { ChatModule } from "@tytapp/chat/chat.module";
import { MatIconModule } from '@angular/material/icon';
import { TaskCompletedComponent } from './petition-page/modals/task-completed/task-completed.component';
import { PetitionsPerTopicComponent } from '@tytapp/app/pages/petition-pages/petitions-per-topic/petitions-per-topic.component';
import { PetitionCardComponent } from '@tytapp/app/pages/petition-pages/petition-card/petition-card.component';
import { AllPetitionsComponent } from '@tytapp/app/pages/petition-pages/all-petitions/all-petitions.component';
import { MatButtonModule } from '@angular/material/button';
import { RecaptchaFormsModule, RecaptchaModule } from '@tytapp/recaptcha';

export { TaskCompletedComponent }

@NamedDialog('whatIsAMission')
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ImageCropperModule,
        TextFieldModule,
        DragDropModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatButtonModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        ChatModule,
        TYTCommonModule,
        CommonUiModule,
        UserModule,
        PollsModule,
        routing,
    ],
    declarations: [
        PetitionCardComponent,
        PetitionListComponent,
        AllPetitionsComponent,
        PetitionPageComponent,
        PetitionsPerTopicComponent,
        PetitionRecentSignersComponent,
        PetitionUpdatesComponent,
        TaskCompletedComponent
    ]
})
export class PetitionPagesModule {

}
